import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Stack, { StackProps } from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import ChipLabel from 'app/components/common/ChipLabel'
import { setDefaultFontSizeAtSystemScale } from 'app/utils/helpers/scaling.helpers'

interface SoldLabelProps {
  sx?: StackProps['sx']
}

const SoldOutLabel: RFC<SoldLabelProps> = ({ sx = {} }) => {
  return (
    <Stack direction="row" sx={sx}>
      <ChipLabel
        startColor="error.main"
        endColor="error.main"
        sx={{
          px: 1,
          py: '1px'
        }}
      >
        <Text
          variant="subtitle2"
          sx={{
            fontWeight: 500,
            color: 'background.default',
            minWidth: 50,
            textAlign: 'center',
            ...Platform.select({
              web: { lineHeight: '20px' },
              native: {
                fontSize: setDefaultFontSizeAtSystemScale(11),
                lineHeight: setDefaultFontSizeAtSystemScale(22)
              }
            })
          }}
        >
          <FormattedMessage defaultMessage="Sold Out" />
        </Text>
      </ChipLabel>
    </Stack>
  )
}

export default SoldOutLabel
